import React, { useState, useEffect } from 'react';

import { Get,Insert } from '../../../backend';
import Loader from '../../../components/Loader';
import { useParams } from "react-router-dom";

import BreadCrumb from '../../../components/BreadCrumb';
import SortableList from '../../../components/SortableList';

export default function Index() {
  const [isLoading, setIsLoading] = useState(false);
  const [sendToServer, setSendToServer] = useState(false);
  const [courses, setCourses] = useState([]);
  const [sortedItemGuids, setSortedItemGuids] = useState([]);
  
  let params = useParams();
  let sortableItems = [];
  
  useEffect(() => {

    async function Load() {
      setIsLoading(true);      
      let result = await Get(`/courses/${params.trainingId}`);
      setCourses(result.body);
      setIsLoading(false);
    }

    async function SaveSorting() {
      
      let result = await Insert(`/course/sort/${params.trainingId}`, sortedItemGuids);
      if (result.ok) {        
      } else {
        alert("Save failed!");
      }
      setSendToServer(false); 
    }

    if (sendToServer) {
      SaveSorting();
    } else {
      Load();
    }
  }, [params.trainingId, sendToServer]); // eslint-disable-next-line react-hooks/exhaustive-deps
 
  const onSortEnd = function(list) {
    let tmp = list.map(i => i.id);
    setSortedItemGuids(tmp);
    setSendToServer(true);
  }
  if (isLoading) {
    return <Loader />
  }

  if (courses.length > 0) {
    sortableItems = courses.map((item) => {
      return {
        id: item.id,
        name:item.name
      }
    });
  }


  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Sort courses</h3>
        <BreadCrumb />
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">             
              
              <SortableList items={sortableItems} onSortEnd={onSortEnd}></SortableList>              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}